import { component, observable, observableArray } from 'knockout-decorators'

import source from './event-gallery.html?raw'
import './event-gallery.less'

export interface EventGalleryParams {
  pics: string[]
}

@component('event-gallery', source)
export class EventGallery {
  @observableArray public pictures: string[] = []
  @observable public selectedPicture: string

  constructor(params: EventGalleryParams) {
    for (const url of params.pics) {
      this.pictures.push(url)
    }
    this.selectedPicture = this.pictures[0]
  }

  public isSelected(url: string): boolean {
    return this.selectedPicture === url
  }

  public select(url: string) {
    this.selectedPicture = url
  }
}
